
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/ashoka",
      function () {
        return require("private-next-pages/case-study/ashoka.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/ashoka"])
      });
    }
  